module.exports = __webpack_public_path__ + "static/media/Portrait-10068_xmas.bbd2f9c3.jpg";